import 'bootstrap/dist/css/bootstrap.min.css';
import ProductSelection from "./ProductSelection";
import {useState} from "react";
import UserSelection from "./UserSelection.CreateOrders";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {Col, Row} from "react-bootstrap";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DeadlineSelection from "./DeadlineSelection.CreateOrders";


const initialState = {
    Items: []
}

/**
 *
 * @param order {initialState}
 * @param onChange
 * @returns {JSX.Element}
 * @constructor
 */
export default function FormCart({
                                      title,
                                      show,
                                      onClose,
                                      onSubmit,
                                      order,
                                      onChange,
                                      isLoading = false,
                                      confirmBtnText
                                  }) {


    const [data, setData] = useState(order ?? initialState)

    const handleClosing = () => onClose && onClose() && setData([])

    //?.Items
    const handleSubmit = () => onSubmit && onSubmit(data)

    const handleChange = (change) => {
        onChange && onChange(change)
        setData(change)
    }

    const handleItemListChange = (items) => handleChange({...data, Items: items, ItemIds: items.map(item => item.Id)})

    return (
        <>
            Ajout au panier

            <Dialog open={show} onClose={handleClosing} maxWidth='lg' fullWidth >

                <DialogTitle>
                    <Row>
                        <Col className='col-auto text-truncate' style={{display: 'grid', placeItems: 'center'}}>
                            {title}
                        </Col>
                        <Col className='col-auto ml-auto'>
                            <IconButton onClick={handleClosing}>
                                <CloseIcon/>
                            </IconButton>
                        </Col>
                    </Row>
                </DialogTitle>

                <DialogContent className='pt-4'>

                    <ProductSelection items={data} onChange={handleItemListChange}/>

                </DialogContent>

                <DialogActions>
                <Button variant='contained' color='warning' disabled={isLoading} style={{backgroundColor: 'orange',color: 'white'}}>
                        {confirmBtnText ?? 'FOR VALIDATION'}
                    </Button>
                    <Button variant='contained' color='primary' onClick={handleSubmit} disabled={isLoading}>
                        {confirmBtnText ?? 'ADD TO CART'}
                    </Button>
                    <Button variant='contained' color='error' disabled={isLoading} style={{backgroundColor: 'red',color: 'white'}}>
                        {confirmBtnText ?? 'REMOVE FROM CART'}
                    </Button>
                </DialogActions>

            </Dialog>

        </>
    )

}
